import axiosInstance from '../plugin/axios';

interface FetchAdminInquiryParams {
  title?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface InquiryDtoRx {
  inquiryId: number;
  title: string;
  createdAt: string;
  passid: string;
  state: string;
}

interface DeleteInquiryDtoTx {
  inquiryId: number[]; // 회원 아이디 배열
}

interface CreateInquiryAnswerDtoRx {
  inquiryId: number; // 1:1 문의 아이디
  createdAt: string; // 등록일 (ISO 8601 date-time 형식)
  passid: string; // 등록 아이디
  title: string; // 문의 제목
  question: string; // 문의 내용
  answer: string;
}

interface CreateInquiryAnswerDtoTx {
  inquiryId: number; // 1:1 문의 아이디
  answer: string; // 답변 내용
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

export const fetchAdminInquiryList = async (
  params: FetchAdminInquiryParams,
): Promise<InquiryDtoRx[]> => {
  try {
    const {
      title,
      offset = 0,
      limit = 10000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<InquiryDtoRx[]>(
      `/api/admin/inquiry`,
      {
        params: {
          title,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminDeleteInquiry = async (
  data: DeleteInquiryDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.delete<ServerResponse>(
      `/api/admin/inquiry`,
      {
        data: data,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Failed to delete members:', error);
    throw error; // 에러 발생 시 처리
  }
};

export const fetchAdminInquiryDetail = async (
  inquiryId: number,
): Promise<CreateInquiryAnswerDtoRx> => {
  try {
    const response = await axiosInstance.get<CreateInquiryAnswerDtoRx>(
      `/api/admin/inquiry/${inquiryId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminInquiryAnswerRegist = async (
  data: CreateInquiryAnswerDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/admin/inquiry`,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminInquiryUpdate = async (
  inquiryId: number,
  data: CreateInquiryAnswerDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/admin/inquiry/${inquiryId}`,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
